const TICKET_STATUS_LABELS = {
    NEW: 'Nuevo',
    OPEN: 'Abierto',
    IN_PROGRESS: 'En progreso',
    PENDING_CUSTOMER: 'Pendiente cliente',
    PENDING_THIRD_PARTY: 'Pendiente tercero',
    RESOLVED: 'Resuelto',
    CLOSED: 'Cerrado',
    CANCELLED: 'Cancelado',
};

const TICKET_PRIORITY_LABELS = {
    LOW: 'Baja',
    MEDIUM: 'Media',
    HIGH: 'Alta',
    URGENT: 'Urgente',
    CRITICAL: 'Crítica',
};

const TICKET_TYPE_LABELS = {
    INCIDENT: 'Incidente',
    REQUEST: 'Solicitud',
    PROBLEM: 'Problema',
    CHANGE: 'Cambio',
    TASK: 'Tarea',
};

const TICKET_SOURCE_LABELS = {
    PORTAL: 'Portal',
    EMAIL: 'Correo',
    PHONE: 'Teléfono',
    CHAT: 'Chat',
    API: 'API',
    INTERNAL: 'Interno',
};

const TICKET_IMPACT_LABELS = {
    LOW: 'Bajo',
    MEDIUM: 'Medio',
    HIGH: 'Alto',
};

const TICKET_URGENCY_LABELS = {
    LOW: 'Baja',
    MEDIUM: 'Media',
    HIGH: 'Alta',
};

const toOptions = (labelsMap = {}) => {
    return Object.keys(labelsMap).map((value) => ({
        value,
        label: labelsMap[value],
    }));
};

const getLabel = (labelsMap = {}, value = '') => {
    return labelsMap[value] || value || '-';
};

export const TICKET_STATUS_OPTIONS = toOptions(TICKET_STATUS_LABELS);
export const TICKET_PRIORITY_OPTIONS = toOptions(TICKET_PRIORITY_LABELS);
export const TICKET_TYPE_OPTIONS = toOptions(TICKET_TYPE_LABELS);
export const TICKET_SOURCE_OPTIONS = toOptions(TICKET_SOURCE_LABELS);
export const TICKET_IMPACT_OPTIONS = toOptions(TICKET_IMPACT_LABELS);
export const TICKET_URGENCY_OPTIONS = toOptions(TICKET_URGENCY_LABELS);

export const getTicketStatusLabel = (value) => getLabel(TICKET_STATUS_LABELS, value);
export const getTicketPriorityLabel = (value) => getLabel(TICKET_PRIORITY_LABELS, value);
export const getTicketTypeLabel = (value) => getLabel(TICKET_TYPE_LABELS, value);
export const getTicketSourceLabel = (value) => getLabel(TICKET_SOURCE_LABELS, value);
export const getTicketImpactLabel = (value) => getLabel(TICKET_IMPACT_LABELS, value);
export const getTicketUrgencyLabel = (value) => getLabel(TICKET_URGENCY_LABELS, value);
